const actualizarContrasenasDeMajat = {
    ActualizarContrasenas: 'SICUS/ActualizarContrasenasDeMajat/ActualizarContrasenas'
}
 
const administracion = {
    actualizarContrasenasDeMajat: actualizarContrasenasDeMajat
}

export default administracion;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICUS/sistema/administracion/administracion.js
// module id = null
// module chunks = 